// Resolución de la pestaña pedida en la ficha del cliente.
// Si el plan no incluye esa capacidad, no se cae en silencio a General.

export const DETAIL_TABS = ['general', 'implementacion', 'correo', 'avisos'] as const;

export type DetailTabId = (typeof DETAIL_TABS)[number];

/** URLs viejas (?tab=compartir, chatbot, …) caen en una sección de Implementación. */
export const LEGACY_DETAIL_SECTIONS = {
  compartir: 'instalar',
  chatbot: 'chatbot',
  integraciones: 'integraciones',
  pipelines: 'etapas',
  sla: 'sla',
} as const;

export type DetailSectionId = (typeof LEGACY_DETAIL_SECTIONS)[keyof typeof LEGACY_DETAIL_SECTIONS] | 'cms';

export interface DetailTabDef {
  id: DetailTabId;
  label: string;
  show: boolean;
}

export interface ResolvedDetailTab {
  activeId: DetailTabId;
  /** Ancla dentro de Implementación. null si la pestaña no tiene sección. */
  section: DetailSectionId | null;
  /** Pestaña pedida que este cliente no tiene en su plan. */
  missing: { id: DetailTabId; label: string } | null;
}

export function resolveDetailTab(
  requested: string | null | undefined,
  tabs: readonly DetailTabDef[],
): ResolvedDetailTab {
  const legacy = requested
    ? LEGACY_DETAIL_SECTIONS[requested as keyof typeof LEGACY_DETAIL_SECTIONS]
    : undefined;
  if (legacy) {
    return { activeId: 'implementacion', section: legacy, missing: null };
  }
  const known = tabs.find((t) => t.id === requested);
  if (known?.show) return { activeId: known.id, section: null, missing: null };
  if (known && !known.show) {
    return {
      activeId: 'general',
      section: null,
      missing: { id: known.id, label: known.label },
    };
  }
  return { activeId: 'general', section: null, missing: null };
}

export function missingTabMessage(label: string): string {
  return `Este cliente no tiene ${label} en su plan.`;
}

export const ACTIVATE_CAPABILITY_LABEL = 'Activar en General → Capacidades';
